import {ApiModel} from './api-model';

export class Value extends ApiModel {
  id: number;
  value: string;
  isLocked: boolean;
  lockStatus: boolean;
  isIncluded = true;
  name: string;
  isTranslated: boolean;
  content: string;
}



// WEBPACK FOOTER //
// ./src/app/models/value.ts